import React from 'react';
import * as Styled from '../../Sizes.styles';
import Children from './Children';
export default (function () {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Children, null), /*#__PURE__*/React.createElement(Styled.ResponsiveWrapper, null, /*#__PURE__*/React.createElement(Styled.Table, null, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "\xA0"), /*#__PURE__*/React.createElement("th", {
    className: "th"
  }, "Dual Size"), /*#__PURE__*/React.createElement("th", {
    className: "th"
  }, "Total Height"), /*#__PURE__*/React.createElement("th", {
    className: "th"
  }, "Chest"), /*#__PURE__*/React.createElement("th", {
    className: "th"
  }, "Waist"), /*#__PURE__*/React.createElement("th", {
    className: "th"
  }, "Hip"), /*#__PURE__*/React.createElement("th", {
    className: "th"
  }, "Inside Leg"))), /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "8 years"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "7-8 yrs"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "128cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "64cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "58cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "70cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "60cm")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "9 years"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "8-9 yrs"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "134cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "65cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "60cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "72cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "63.5cm")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "10 years"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "9-10 yrs"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "140cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "71.5cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "61.5cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "77cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "66cm")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "11 years"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "10-11 yrs"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "146cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "73cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "63cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "79cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "70.5cm")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "12 years"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "11-12 yrs"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "152cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "78cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "65cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "84cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "71.5cm")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "13 years"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "12-13 yrs"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "158cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "80cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "66cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "86cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "75.5cm")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "14 years"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "13-14 yrs"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "164cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "82.5cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "67.5cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "88cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "77.5cm")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "15 years"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "14-15 yrs"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "166cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "84.5cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "68.5cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "90cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "92cm")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "16 years"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "15-16 yrs"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "166cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "87cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "69cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "92cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "78.5cm"))))));
});